import { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import StaticPagesApi from 'libs/api/website/staticPages';

const useSingleStaticPage = () => {
  const { id: routeId } = useParams();
  const [singleItem, setSingleItem] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!routeId) {
      return;
    }

    let cancelled = false;

    (async () => {
      setLoading(true);
      try {
        const response = await StaticPagesApi.show(routeId);
        const page = response.data?.success
          ? response.data.static_page
          : response.data?.static_page;

        if (!cancelled) {
          setSingleItem(page || {});
        }
      } catch {
        if (!cancelled) {
          setSingleItem({});
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [routeId]);

  const viewItem = useMemo(
    () => ({
      ...singleItem,
      id: singleItem?.id || routeId,
    }),
    [singleItem, routeId],
  );

  return {
    singleItem: viewItem,
    loading,
  };
};

export default useSingleStaticPage;
